export default function Services() {
  const services = [
    {
      title: '売買仲介サービス',
      description: '高級住宅の売買において、適正価格の査定から契約締結まで、専門スタッフが一貫してサポートいたします。',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20luxury%20house%20exterior%20with%20modern%20architecture%2C%20clean%20white%20walls%20and%20natural%20wood%20accents%2C%20manicured%20garden%2C%20professional%20real%20estate%20photography%2C%20bright%20daylight%2C%20minimalist%20composition%20with%20simple%20light%20background%2C%20high-end%20property%20showcase%20style&width=720&height=960&seq=service-001&orientation=portrait'
    },
    {
      title: '賃貸管理サービス',
      description: '資産価値を維持しながら、安定した賃貸収入を実現するための総合的な管理サービスをご提供いたします。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20luxury%20apartment%20interior%20living%20room%2C%20sophisticated%20minimalist%20design%2C%20premium%20furniture%20and%20fixtures%2C%20natural%20lighting%2C%20professional%20architectural%20photography%2C%20clean%20simple%20background%2C%20neutral%20tones%2C%20high-quality%20real%20estate%20image&width=720&height=960&seq=service-002&orientation=portrait'
    },
    {
      title: '資産コンサルティング',
      description: '不動産投資のプロフェッショナルとして、長期的な視点での資産形成をサポートいたします。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20business%20consultation%20scene%2C%20elegant%20modern%20office%20interior%2C%20clean%20desk%20with%20documents%20and%20laptop%2C%20natural%20window%20light%2C%20minimalist%20corporate%20photography%20style%2C%20simple%20light%20background%2C%20trustworthy%20and%20professional%20atmosphere&width=720&height=960&seq=service-003&orientation=portrait'
    }
  ];

  return (
    <section id="services" className="py-32 bg-[#FAFAF9]">
      <div className="max-w-[1200px] mx-auto px-20">
        <div className="mb-24">
          <h3
            className="text-[42px] leading-tight font-semibold text-[#1A1A1A]"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            お客様の大切な
            <br />
            資産をお守りする
            <br />
            プロフェッショナルサービス
          </h3>
        </div>

        <div className="flex justify-center gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="w-[360px] bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <div className="h-[312px] bg-white flex items-center justify-center p-6">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-contain"
                  style={{ filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.08))' }}
                />
              </div>
              <div className="p-8">
                <h4
                  className="text-[18px] font-medium text-[#1A1A1A] mb-3"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  {service.title}
                </h4>
                <p
                  className="text-[13px] text-[#666666] leading-relaxed"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
